var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3C21.0544 3 21.9182 3.81588 21.9945 4.85074L22 5V19C22 20.0544 21.1841 20.9182 20.1493 20.9945L20 21H4C2.94564 21 2.08183 20.1841 2.00549 19.1493L2 19V5C2 3.94564 2.81588 3.08183 3.85074 3.00549L4 3H20ZM9.87852 12.0503L4.22166 17.7071C4.15418 17.7746 4.07946 17.8304 4 17.8746V19H20V17.8747C19.9204 17.8305 19.8456 17.7747 19.778 17.7071L16.9496 14.8787L16.2425 15.5858L16.4496 15.7929C16.8401 16.1834 16.8401 16.8166 16.4496 17.2071C16.0591 17.5976 15.4259 17.5976 15.0354 17.2071L9.87852 12.0503ZM20 5H4V15.1003L8.99463 10.1057C9.45025 9.65009 10.17 9.61972 10.6609 10.0146L10.7624 10.1057L14.8283 14.1716L16.0657 12.9341C16.5214 12.4785 17.2411 12.4482 17.732 12.843L17.8335 12.9341L20 15.1007V5ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicLine);
export default __webpack_public_path__ + "static/media/pic_line.7a24220c72e1838c1c7a0f23208830cd.svg";
export { ForwardRef as ReactComponent };